define('usuario-solicitacao-interesse-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('usuario.solicitacao.interesse.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('UsuarioSolicitacaoInteresse', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {
        getList:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioSolicitacaoInteresse.getList'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        delete:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioSolicitacaoInteresse.delete'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        edt:function(data){
          return $q(function (resolve, reject) {
            return $http.get(appRoute.linkTo('usuarioSolicitacaoInteresse.edt', data)).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        save:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioSolicitacaoInteresse.save'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        }
      }
    }]);
});
